module.exports = __webpack_public_path__ + "static/img/gather-market.5813a113.png";